import React from "react";
const EstimatedPerformance = ({
  unit,
  flowRate,
  orificeDiscSize,
  dropletSize,
  sprayAngle,
  currentTab,
}) => {
  return (
    <div className="estimated-performance">
      <h2>Estimated Performance</h2>
      <div className="estimated-table">
        {flowRate && (
          <div className="table-row">
            <span>FLOW RATE</span>
            <div className="result">{flowRate}</div>
            <span>{unit === "metric" ? "L/hr" : "gal/min"}</span>
          </div>
        )}

        {orificeDiscSize && currentTab !== "wear-parts" && (
          <div className="table-row">
            <span>ORIFICE DISC SIZE</span>
            <div className="result">{orificeDiscSize}</div>
          </div>
        )}

        {dropletSize && (
          <div className="table-row">
            <span>DROPLET SIZE</span>
            <div className="result">{dropletSize}</div>
            <span>um (D32)</span>
          </div>
        )}

        {sprayAngle && (
          <div className="table-row">
            <span>
              SPRAY ANGLE at {unit === "metric" ? "69 bar" : "1000 psi"}
            </span>
            <div className="result">{sprayAngle}</div>
            <span>degrees</span>
          </div>
        )}
      </div>
    </div>
  );
};

export default EstimatedPerformance;